module.exports = __webpack_public_path__ + "img/icon-fine.d8568838.svg";